import { createFileRoute } from "@tanstack/react-router";
import { AdminUserDetail } from "@/pages/Admin/AdminUserDetail";

export const Route = createFileRoute("/admin/users/$publicId")({
  component: AdminUserDetailRoute,
});

function AdminUserDetailRoute() {
  const { publicId } = Route.useParams();
  return <AdminUserDetail publicId={publicId} />;
}
